// extracted by mini-css-extract-plugin
export default {"container":"HomePageStaff_container__nu0+l","staffSection":"HomePageStaff_staffSection__mv6fS","scrollButtons":"HomePageStaff_scrollButtons__0A3LK"};